import * as type from './types'


export function createItemmap(itemmap) {
    return {
        type: type.CREATE_ITEMMAP,
        payload: itemmap,
        txn: 'initiated',
    };
}


export function savedItemmap(itemmap, txn, msg = '') {
    return {
        type: type.SAVED_ITEMMAP,
        payload: itemmap,
        txn: txn,
        msg: msg,
        diff: true
    };
}


export function editItemmap(itemmap) {
    return {
        type: type.EDIT_ITEMMAP,
        payload: itemmap,
        txn: 'initiated',
    };
}


export function fetchItemmap() {
    return {
        type: type.FETCH_ITEMMAP,
    };
}


export function fetchedItemmap(itemmap) {
    return {
        type: type.FETCHED_ITEMMAP,
        payload: itemmap
    };
}


export function searchItemmap(itemmap) {
    return {
        type: type.SEARCH_ITEMMAP,
        payload: itemmap
    };
}


export function storeSearchItemmapResult(itemmap) {
    return {
        type: type.STORE_SEARCH_ITEMMAP_RESULT,
        payload: itemmap
    };
}


export function deleteItemmap(itemmap) {
    return {
        type: type.DELETE_ITEMMAP,
        payload: itemmap
    };
}


export function deletedItemmap(msg) {
    return {
        type: type.DELETED_ITEMMAP,
        payload: msg
    };
}


export function setNotifyDone(props) {
    return {
        type: type.NOTIFICATION_DONE_ITEMMAP,
        payload: props
    };
}

export function filterItems(options) {
    return {
        type: type.FILTER_ITEMS,
        payload: options
    };
}
